// extracted by mini-css-extract-plugin
module.exports = {"root":"dummy_root__3xJQX","infos":"dummy_infos__21S2E","dummy":"dummy_dummy__2wXZR"};